import React, { useState, useEffect } from "react";
import moment from "moment";
import submit from "submit-form";
import round from "lodash/round";

import { formattedTarget } from "../../../utils/actuals";
import SvgIcon from "../../../parts/SvgIcon";
import TooltipPortal from "../../../parts/tooltip-portal";

export const VideoListTable = ({
  locals,
  query,
  compareState,
  setVideosToCompareState,
  initialDateState,
  endDateState,
  sortState,
  previousExercises,
  setPreviousExercises,
  counter,
  setCounter,
  videosToShow,
  setVideosToShow,
  videosToFilter,
  setVideosToFilter,
  isCheckIn = false,
}) => {
  const videoLocals = locals.videoListMetrics
    ? locals.videoListMetrics.exercises
    : [];
  const hasNextPage = locals.videoListMetrics
    ? locals.videoListMetrics.hasNextPage
    : false;
  const [formState, setFormState] = useState([""]); //
  const formatedDays = ["01", "02", "03", "04", "05", "06", "07", "08", "09"];
  const userMetrics = locals.activeUser.units === "imperial" ? "lb" : "kg";
  /**
   * add more videos to the state
   */
  useEffect(() => {
    if (!query.pageToShow || query.pageToShow === 1) {
      setPreviousExercises(videoLocals);
      query.exerciseFilters && JSON.parse(query.exerciseFilters).length > 0
        ? setVideosToShow(
            videosToFilter.filter((element) =>
              JSON.parse(query.exerciseFilters).includes(element.name)
            )
          )
        : setVideosToShow(videoLocals);
      setVideosToFilter(videoLocals);
    } else {
      if (!query.modal) {
        const data = [];
        previousExercises.forEach((element) => {
          data.push(element);
        });
        videoLocals.forEach((element) => {
          data.push(element);
        });
        const filteredList = [...new Set(data.map(JSON.stringify))].map(
          JSON.parse
        );
        setPreviousExercises(filteredList);
        setVideosToShow(filteredList);
        setVideosToFilter(filteredList);
      }
    }
  }, [videoLocals, query.exerciseFilters]);
  /**
   * Load more videos
   */
  // const loadMoreVideos = () => {
  //   setCounter(counter + 1);
  //   submit(`/actions/refresh/?`, {
  //     method: "GET",
  //     body: {
  //       fromDate: initialDateState,
  //       toDate: endDateState,
  //       sortDate: sortState,
  //       pageToShow: counter + 1,
  //     },
  //   });
  // };
  /**
   * Reset the compare state
   */
  useEffect(() => {
    if (!compareState) {
      setFormState([""]);
      setVideosToCompareState([]);
    }
  }, [compareState]);
  /**
   * Choose videos to compare
   * @param {*} value
   */
  const handleSelectionChange = (value) => {
    let data = JSON.parse(JSON.stringify(formState));
    if (!formState.includes(value)) {
      if (formState.length < 2) {
        data.length === 1 && data[0].length === 0
          ? (data = [value])
          : data.push(value);
      }
    } else {
      if (formState.length > 0) {
        const filetered = data.filter((val) => val != value);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setFormState(data);
    setVideosToCompareState(data);
  };
  return (
    <tbody role="table-body">
      {videosToShow.map((exercise, index) => {
        const precision = locals.activeUser.units === "metric" ? 2 : 1;
        const load =
          exercise.outcomes && exercise.outcomes?.outcome?.load
            ? `${_.round(
                locals.fromMetric(
                  exercise.outcomes.outcome.load,
                  locals.activeUser.units
                ),
                precision
              )} ${userMetrics}`
            : 0;

        const athleteId = locals.athlete
          ? locals.athlete._id
          : locals.activeUser._id;

        const modalRedirect = exercise.reviewedByTheCoach
          ? `/actions/refresh?modal[type]=watch-video-list&mediaId=${
              exercise.videoId
            }&originalId=${exercise.videoOriginal}&mediaAthleteId=${
              exercise.uploaderId || athleteId
            }`
          : `/actions/refresh?modal[type]=watch-video-list&mediaId=${
              exercise.videoId
            }&originalId=${exercise.videoOriginal}&mediaAthleteId=${
              exercise.uploaderId || athleteId
            }&exerciseToEdit=${exercise.exerciseId}&reviewedByTheCoach=${
              exercise.reviewedByTheCoach
            }&setIndex=${parseInt(exercise.setIndex)}&videoIndex=${parseInt(
              exercise.videoSet
            )}`;

        return (
          <tr key={`${exercise.videoId}-${index}-${exercise._id}`}>
            {compareState && (
              <td className="col-compare">
                <SvgIcon
                  src={
                    formState.includes(exercise.videoOriginal)
                      ? "/img/new-icons/checked-square.svg"
                      : "/img/new-icons/unchecked-square.svg"
                  }
                  alt="checked"
                  onClick={() => handleSelectionChange(exercise.videoOriginal)}
                  noFilterOnLight={formState.includes(exercise.videoOriginal)}
                />
              </td>
            )}

            <td>
              {formatedDays.includes(
                moment(exercise.date, "YYYYMMDD").format("DD")
              )
                ? moment(exercise.date, "YYYYMMDD").format("MMM D, YYYY")
                : moment(exercise.date, "YYYYMMDD").format("MMM DD, YYYY")}
            </td>
            <td>
              {exercise.displayName.charAt(0).toUpperCase() +
                exercise.displayName.slice(1)}
            </td>
            <td className="protocol">
              {formattedTarget(
                exercise.outcomes ? exercise.outcomes.outcome : {},
                exercise.exercise.type === "primary" ||
                  exercise.exercise.type === "secondary",
                exercise.set.percentRepMax
                  ? exercise.set.percentRepMax
                  : undefined,
                locals.activeUser.units,
                load,
                locals.activeUser.intensityMeasure,
                locals.activeUser.intensityMeasure === "rpe" ? false : true,
                true
              )}{" "}
              (Set #{exercise.setNumber})
            </td>
            <td className="protocol">
              <div>
                {exercise.comments == null ? (
                  <span></span>
                ) : (
                  <TooltipPortal
                    id={"video-table-comment"}
                    body={exercise.comments}
                    childrenContainerClass={"tooltip-coach"}
                  >
                    {exercise.comments.length > 120
                      ? exercise.comments.substring(0, 120) + "..."
                      : exercise.comments}
                  </TooltipPortal>
                )}
              </div>
            </td>
            <td>
              {exercise.outcomes ? (
                <TooltipPortal
                  id={"video-table-status"}
                  body={
                    exercise.outcomes.status.charAt(0).toUpperCase() +
                    exercise.outcomes.status.slice(1)
                  }
                  childrenContainerClass={"tooltip-coach"}
                >
                  <div
                    className={`chip ${
                      exercise.outcomes.status === "completed"
                        ? "success"
                        : exercise.outcomes.status === "incomplete"
                        ? "danger"
                        : "warning"
                    }`}
                  ></div>
                </TooltipPortal>
              ) : (
                <div>{""}</div>
              )}
            </td>
            <td>
              {exercise.reviewedByTheCoach && (
                <div className="chip info check"></div>
              )}
            </td>
            <td>
              <a href={modalRedirect}>
                <SvgIcon
                  className="play-icon"
                  src="/img/new-icons/play-with-gradient.svg"
                  alt="play"
                  noFilterOnLight={true}
                />
              </a>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};
